export default "__VITE_ASSET__BAP8AKQa__"